import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 12,
    type: CHECKLIST_ITEM_TYPE.SEND_REVIEW_REQUEST,
    manifestKey: 'SEND_REVIEW_REQUEST',

    try_it: {
        button_label: 'Send Review Request',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'SendReviewRequestCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { review_url: 'https://g.page/r/demo-review-url' },
        },
    },
    pre_flight_diff: [
        'Step 1: Review request email dispatched with encrypted review URL',
        'Step 2: POST /checklist/{iid}/complete/ — checklist item: PENDING → YES',
        'task_review_request_sent Action logged to lead timeline',
        'Re-send after reopen generates a NEW encrypted URL (prior URL remains valid)',
        'Email added to lead\'s outgoing email tab',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
